import { is } from 'ramda';
import { combineReducers } from 'redux';

import { GLOBAL_ERROR, RESET_GLOBAL_ERROR } from '../actions/errors';
import {
  LOAD_DOCUMENTS_BY_IDS_FAILURE,
  LOAD_DOCUMENT_BY_ID_FAILURE,
  LOAD_DOCUMENT_BY_UID_FAILURE,
  LOAD_DOCUMENT_FAILURE,
  LOAD_PAGINATED_QUERY_FAILURE,
  LOAD_SINGLE_TYPE_DOC_FAILURE,
} from '../actions/prismic';

export const error = ({
  type,
  reset = null,
  mapActionToKey,
}: {
  type: string;
  reset?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapActionToKey?: (action: Record<string, any>) => string;
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}): ((state: ErrorsState, action: any) => ErrorsState) => {
  const isManyKeyState = is(Function, mapActionToKey);
  const initialState: ErrorsState = isManyKeyState ? {} : null;
  const types = reset ? [type, reset] : [type];

  // TODO
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateError = (state: any, action: any): any => {
    switch (action.type) {
      case type:
        return action.payload;
      case reset:
        return null;
      /* istanbul ignore next */
      default:
        return state;
    }
  };

  // TODO
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleErrorAction = (state: Error, action: any): Error => {
    if (isManyKeyState) {
      const key: string = mapActionToKey(action);

      return {
        ...state,
        [key]: updateError(state?.[key], action),
      };
    }

    return updateError(state, action);
  };

  // TODO
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (state: ErrorsState = initialState, action: any): ErrorsState => {
    if (!~types.indexOf(action.type)) {
      return state;
    }

    if (action.lang) {
      return {
        ...state,
        [action.lang]: handleErrorAction(state[action.lang], action),
      };
    }

    return handleErrorAction(state, action);
  };
};

export default combineReducers({
  global: error({ type: GLOBAL_ERROR, reset: RESET_GLOBAL_ERROR }),
  loadDocById: error({
    type: LOAD_DOCUMENT_BY_ID_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapActionToKey: (action: any) => action.id,
  }),
  loadDocByUid: error({
    type: LOAD_DOCUMENT_BY_UID_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapActionToKey: (action: any) => action.id,
  }),
  loadDocByIds: error({
    type: LOAD_DOCUMENTS_BY_IDS_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapActionToKey: (action: any) => action.ids,
  }),
  loadDocByType: error({
    type: LOAD_SINGLE_TYPE_DOC_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapActionToKey: (action: any) => action.id,
  }),
  loadDoc: error({
    type: LOAD_DOCUMENT_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapActionToKey: (action: any) => action.id,
  }),
  loadDocs: error({
    type: LOAD_PAGINATED_QUERY_FAILURE,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapActionToKey: (action: any) => action.key,
  }),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Error = Record<string, any>;
export type ErrorsState = Record<string, Error>;
